import { nanoid } from 'nanoid';

const TAB_ID_STORAGE_KEY = 'team_canvas_lock_tab_id';

/**
 * 获取当前浏览器页签的画布锁 tab_id（sessionStorage UUID，同画布仅第一页可编辑）。
 */
export function getTeamCanvasLockTabId(): string {
  if (typeof window === 'undefined') {
    return nanoid();
  }
  try {
    // eslint-disable-next-line ban/ban
    const existing = sessionStorage.getItem(TAB_ID_STORAGE_KEY);
    if (existing) {
      return existing;
    }
    const next = nanoid();
    // eslint-disable-next-line ban/ban
    sessionStorage.setItem(TAB_ID_STORAGE_KEY, next);
    return next;
  } catch {
    return nanoid();
  }
}
